(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name config.factory:Config
   *
   * @description
   *
   */
  angular
    .module('vcutils.config')
    .factory('Config', Config);


  Config.$inject = ['restmod'];

  function Config(restmod) {
    return restmod.model('/routes/appconfig');
  }
}());
